import { useNavigate, useLocation } from 'react-router'
import { useAuth } from '@/hooks/auth/useAuth'
import { useAuthForm } from '@/hooks/auth/useAuthForm'
import { loginService } from '@/services/auth'
import type { LoginPayload, LoginResponse } from '@/services/auth'

const useForm = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { setSession } = useAuth()
  const from = (location.state as { from?: Location })?.from?.pathname

  return useAuthForm<LoginResponse, LoginPayload>({
    mutationFn: loginService,
    onSuccess: (session) => {
      setSession(session)
      navigate(from ?? '/painel/agendas')
    },
  })
}

export default useForm
